<template>
    <div :class="['borderModal', seeType == 'tishi' ? 'RewardModal' : '', { 'rules-modal': seeType == 'Rules' }]">
        <img class="closed" @click="() => {
            $emit('closeModal')
        }" src="@/assets/imgs/AutumnFestival/close.png" alt="" />
        <!-- <img class="bg" src="@/assets/imgs/chidrenDay/seeBg.png" alt=""> -->
        <div class="RankBody p" v-if="seeType == 'Ranking'">
            <div class="signIn_mode">
                <div class="mode_item" :class="{ active: modeType === 'COUPLE' }" @click="switchMode('COUPLE')">
                    情侣模式
                </div>
                <div class="mode_item" :class="{ active: modeType === 'SISTER' }" @click="switchMode('SISTER')">
                    闺蜜模式
                </div>
            </div>
            <div class="tit">
                <div class="rank">名次</div>
                <div class="name">角色昵称</div>
                <div class="num" v-if="modeType === 'COUPLE'">累计情侣红心</div>
                <div class="num" v-else>累计蜜糖之心</div>
            </div>
            <div class="items">
                <div class="itemList" v-for="(value, index) in infoData" :key="index">
                    <div class="rank">{{ value.rank }}</div>
                    <div class="name" :title="value.usernick">{{ value.usernick }}</div>
                    <div class="num">{{ value.family }}</div>
                    <!-- <div class="num">{{ value.exchangeTotal }}</div> -->
                </div>
            </div>
        </div>
        <div class="hit" v-if="seeType == 'Ranking'">10分钟刷新一次,仅显示前10名</div>
        <!-- 记录 -->
        <div class="Record p" v-if="seeType == 'Record'">
            <div class="tit">
                <div class="rank">等级</div>
                <div class="name">奖品</div>
                <!-- <div class="num">奖励</div> -->
                <div class="num">数量</div>
            </div>
            <div class="items">
                <div class="itemList" v-for="(value, index) in RecordList" :key="index">
                    <div class="rank">{{ value.level }}</div>
                    <div class="name" :title="value.name">{{ value.name }}</div>
                    <!-- <div class="num">{{ value.prizeNo }}</div> -->
                    <div class="num">{{ value.quantity }}</div>
                </div>
            </div>
            <div class="Record_btn">
                <el-pagination background :hide-on-single-page="true" :page-size='10' :total="total"
                    layout="prev, pager, next" @current-change="pagination_change">
                </el-pagination>
            </div>
        </div>
        <!-- 中秋活动规则与奖池概率公示（仅展示，实际配置由接口提供） -->
        <div class="Rules p" v-if="seeType == 'Rules'">
            <div class="rule-section">
                <div class="section-title">活动规则</div>
                <ul class="rule-list">
                    <li><span class="num">1</span><div class="content">活动时间为2026年9月23日14:00 — 10月8日24:00，逾期活动入口将关闭</div></li>
                    <li><span class="num">2</span><div class="content">团圆币和幸运月饼为活动期间限定道具，活动结束后将自动清零/回收，请及时使用</div></li>
                    <li><span class="num">3</span><div class="content">抽奖概率为公示值，实际以奖池配置为准</div></li>
                    <li><span class="num">4</span><div class="content">累计抽奖奖励限领一次，达到对应抽数后请手动领取</div></li>
                    <li><span class="num">5</span><div class="content">兑换商店道具库存不限（标注不限购的商品），但活动仅开放16天，请合理安排兑换计划</div></li>
                    <li><span class="num">6</span><div class="content">如遇到活动异常情况，请联系客服处理</div></li>
                </ul>
            </div>
            <div class="rule-section">
                <div class="section-title">奖池内容及概率</div>
                <div class="probability-table">
                    <div class="tr th"><span>层级</span><span>奖品</span><span>概率</span><span>保底</span></div>
                    <div class="tr"><span>S（最高级）</span><span>【金秋绝版】限定礼盒 ×1</span><span>0.05%</span><span>无保底</span></div>
                    <div class="tr"><span>A</span><span>动态表情自选兑换凭证 ×1</span><span>0.55%</span><span>150抽</span></div>
                    <div class="tr"><span>B</span><span>金秋套装自选兑换凭证 ×1</span><span>0.80%</span><span>100抽</span></div>
                    <div class="tr"><span>C</span><span>随机饰品 ×1</span><span>1.50%</span><span>80抽</span></div>
                    <div class="tr"><span>D</span><span>团圆币x500</span><span>6.10%</span><span>—</span></div>
                    <div class="tr"><span>E</span><span>团圆币x200</span><span>32.00%</span><span>—</span></div>
                    <div class="tr"><span>F</span><span>团圆币x50 + 泡点x9999</span><span>59.00%</span><span>—</span></div>
                </div>
            </div>
        </div>
        <!-- 抽奖奖励 -->
        <div class="Reward" v-if="seeType == 'Reward'">
            <div class="item" v-for="(value, index) in seeData.allRewards" :key="index">

                <img class="RewardImg" :src="value.itemImg || value.imageUrl" alt="">
                <p :style="{ 'color': value.color }">{{ value.name }}X{{ value.quantity }}</p>

            </div>
            <div class="btn">
                <img src="@/assets/imgs/AutumnFestival/oneExtract.png" @click="() => {
                    $emit('seeReward', 'one')
                    // seeType = 'tishi'
                    // seeData ={type:'one'}
                }" alt="" />
                <img src="@/assets/imgs/AutumnFestival/tenExtract.png" alt="" @click="() => {
                    $emit('seeReward', 'ten')
                }" />
            </div>
        </div>
        <!-- 商城兑换 -->
        <div class="Shop p" v-if="seeType == 'Shop'">
            <div class="items">
                <div class="tit">您确定要兑换 <span>{{ seeData.itemName }}</span> 吗</div>
                <img :src="seeData.itemImg" alt="">
                <!-- <img src="https://download-wx.qtthtech.com/shop/item/0/5002.png" alt=""> -->
                <div class="Shophit">本次操作不可逆</div>
            </div>
            <div class="ShopBtn">
                <div class="ShopConfirm" @click="() => {
                    $emit('seeConfirm', { data: seeData, type: 'shop' })
                }">确认</div>
                <div class="ShopClosed" @click="() => {
                    $emit('closeModal')
                }">取消</div>
            </div>
        </div>
        <!-- 追加奖励选择 -->
        <div class="RewardSelection p" v-if="seeType == 'RewardSelection'">
            <div class="items" v-for="(value, index) in seeData.rewardList" :key="index"
                :class="{ 'selected': selectedItem === value }" @click="selectItem(value)">
                <div class="sex">
                    <img v-if="value.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                    <img v-else-if="value.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                    <img v-else-if="value.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                    <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                </div>
                <img :src="value.itemImg" alt="">
                <!-- <img src="https://download-wx.qtthtech.com/shop/item/0/5002.png" alt=""> -->
                <p>{{ value.name }}</p>
            </div>
            <div class="RewardSelection">
                <div class="btn" :class="{ 'disabled': !selectedItem }" @click="() => {
                    $emit('seeConfirm', { data: selectedItem, seeData: seeData, type: 'RewardSelection' })
                }">确定</div>
            </div>
        </div>
        <div class="hit" v-if="seeType == 'RewardSelection'">点击选择心仪的商品</div>

        <!-- 兑换奖励选择 -->
        <div class="RewardSelection p" v-if="seeType == 'ExchangeRewards'">
            <div class="items" v-for="(value, index) in seeData.rewardList" :key="index"
                :class="{ 'selected': selectedItem === value }" @click="selectItem(value)">
                <div class="sex">
                    <img v-if="value.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                    <img v-else-if="value.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                    <img v-else-if="value.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                    <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                </div>
                <img class="zoomable-prize" :src="value.itemImg || value.imageUrl" alt=""
                    title="点击放大查看" @click.stop="previewPrize(value)" />
                <p>{{ value.name || value.bundleName }}</p>
            </div>
            <div class="RewardSelection">
                <div class="btn" :class="{ 'disabled': !selectedItem }" @click="ExchangeRewardsFun(selectedItem)">确定
                </div>
            </div>
        </div>
        <div class="hit exchange-hint" v-if="seeType == 'ExchangeRewards'">
            <div class="exchange-guide">点击图片放大 · 点击名称或空白处选择奖品</div>
            <div class="voucher-counts">
                <span>累计 <b>{{ seeData.totalNum }}</b></span>
                <span class="available-count">可用 <b>{{ seeData.availableNum }}</b></span>
                <span>已使用 <b>{{ seeData.usedNum }}</b></span>
            </div>
        </div>
        <!-- 兑换全勤奖励 -->
        <div class="RewardSelection p" v-if="seeType == 'FullAttendance'">
            <p class="attendance-hint">全勤奖：以下所有奖品中自选一项</p>
            <p class="attendance-hint" v-if="!seeData.list.length">暂未配置全勤奖奖品</p>
            <div class="items" v-for="value in seeData.list" :key="value.rewardNo"
                :class="{ 'selected': selectedItem === value }" @click="selectItem(value)">
                <div class="sex" v-if="value.sex == 1 || value.sex == 2 || value.sex == 3">
                    <img v-if="value.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                    <img v-else-if="value.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                    <img v-else-if="value.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                </div>
                <img :src="value.itemImg || value.imageUrl" alt="">
                <!-- <img src="https://download-wx.qtthtech.com/shop/item/0/5002.png" alt=""> -->
                <p>{{ value.name || value.bundleName }}</p>
                <p v-if="value.quantity">×{{ value.quantity }}</p>
            </div>
            <div class="RewardSelection">
                <div class="btn attendance-claim-btn" :class="{ 'disabled': !selectedItem || !seeData.canClaimAttendanceReward || attendanceClaiming }"
                    @click="FullAttendanceFun">{{ attendanceClaiming ? '领取中…' : seeData.attendanceRewardClaimed ? '已领取' : !seeData.fullAttendance ? '未完成全勤' : !seeData.canClaimAttendanceReward ? '暂不可领取' : '领取奖励' }}
                </div>
            </div>
        </div>
        <!-- 兑换 -->
        <div class="Exchange p" v-if="seeType == 'Exchange'">
            <p class="hint">幸运月饼不足，需要使用1个白金币兑换1个幸运月饼？</p>
            <!-- 兑换图展示 -->
            <div class="conversion_img">
                <img src="@/assets/imgs/chidrenDay/gold.png" alt="">
                <p>1:1</p>
                <img src="@/assets/imgs/chidrenDay/zhu.png" alt="">
            </div>
            <!-- 兑换 -->
            <div class="conversion_input">
                <span>兑换 :</span>
                <input type="text" v-model="conversion_number"
                    @input="conversion_number = conversion_number.replace(/[^\d]/g, '').replace(/^0+/, '')">
            </div>
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="ExchangeLotteryCurrencyConfirmFun">确认</div>
            </div>

            <div class="CurrencySurplus">
                白金币剩余：{{ seeData.drawTokenBalance }}
            </div>
        </div>
        <!-- 跳转充值页面 -->
        <div class="goRecharge p" v-if="seeType == 'goRecharge'">
            <p class="hint">您当前白金币不足，是否跳转充值页面？</p>
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="goRechargeConfirmFun">确认</div>
            </div>
        </div>
        <!-- 抽奖提示 -->
        <div class="tishi p" v-if="seeType == 'tishi'">
            <p class="hint">确定支付吗</p>
            <p class="hint">本次消耗：{{ seeData.type == 'one' ? '2' : '18' }}幸运月饼</p>
            <p class="hint">确定支付后将为您
                <span style="color: #995000; font-size: 20px; font-weight: 700;">1：1</span>
                兑换：白金币 - 幸运月饼
            </p>
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="tishiConfirmFun">确认</div>
            </div>
        </div>
        <!-- 补签提示 -->
        <div class="tishi p" v-if="seeType == 'buqian'">
            <p class="hint">确定补签吗</p>
            <p class="hint">本次消耗：20白金币</p>
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="buqianConfirmFun">确认</div>
            </div>
        </div>
        <!-- 奖池预览 -->
        <div class="PrizePool p" v-if="seeType == 'PrizePool'">
            <div class="hint-title">
                <span>当前奖池预览</span>
            </div>

            <div class="items">
                <div :class="['item', item.obtained ? 'obtained' : '']" v-for="(item, index) in seeData" :key="index">
                    <!-- 稀有度角标/背光 -->
                    <div class="card-glow"></div>

                    <!-- 性别标识 -->
                    <div class="sex" v-if="item.sex">
                        <img v-if="item.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                        <img v-else-if="item.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                        <img v-else-if="item.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                        <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                    </div>

                    <!-- 道具展示框（加底座感） -->
                    <div class="img-wrapper">
                        <img class="prize_img zoomable-prize" :src="item.itemImg || item.imageUrl" :alt="item.itemName"
                            title="点击放大查看" @click.stop="previewPrize(item)" />
                    </div>

                    <!-- 道具名称及数量 -->
                    <div class="name-box">
                        <p class="name" :style="{ color: item.color || '#ffffff' }">
                            {{ item.level }} {{ item.name || item.bundleName }}
                        </p>
                        <span class="num-tag" v-if="item.quantity > 1">×{{ item.quantity }}</span>
                    </div>

                    <img v-if="item.obtained" class="Obtain" src="@/assets/imgs/Qingliang_yixia/sign_in_ok.png" alt="">

                </div>
            </div>
        </div>
        <!-- 兑换奖励预览 -->
        <div class="PrizePool p" v-if="seeType == 'SeeExchangeRewards'">
            <div class="hint-title">
                <span>{{ seeData.level }}</span>
            </div>

            <div class="items">
                <div class="item" v-for="(item, index) in seeData.allRewards" :key="index">
                    <!-- 稀有度角标/背光 -->
                    <div class="card-glow"></div>

                    <!-- 性别标识 -->
                    <div class="sex" v-if="item.sex">
                        <img v-if="item.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                        <img v-else-if="item.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                        <img v-else-if="item.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                        <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                    </div>

                    <!-- 道具展示框（加底座感） -->
                    <div class="img-wrapper">
                        <img class="prize_img zoomable-prize" :src="item.itemImg || item.imageUrl" :alt="item.itemName"
                            title="点击放大查看" @click.stop="previewPrize(item)" />
                    </div>

                    <!-- 道具名称及数量 -->
                    <div class="name-box">
                        <p class="name" :style="{ color: item.color || '#ffffff' }">
                            {{ item.name }}
                        </p>
                        <span class="num-tag" v-if="item.quantity > 1">×{{ item.quantity }}</span>
                    </div>

                    <img v-if="item.obtained" class="Obtain" src="@/assets/imgs/Qingliang_yixia/sign_in_ok.png" alt="">

                </div>
            </div>
        </div>

        <!-- 心直购  提示-->
        <div class="directPurchasing p" v-if="seeType == 'directPurchasing'">
            <p class="hint">确定要使用{{ seeData.price }}白金币直接购买{{ seeData.name }}吗？</p>
            <p class="hint">当前礼包价值：{{ seeData.heartNum }}{{ seeData.heartName }}</p>
            <p class="hint">确认后将无法取消，请谨慎操作</p>
            <img class="Gift" v-if="seeData.packageId == 1" src="@/assets/imgs/AutumnFestival/directPurchasing/1.png" alt="">
            <img class="Gift" v-else-if="seeData.packageId == 2" src="@/assets/imgs/AutumnFestival/directPurchasing/2.png" alt="">
            <img class="Gift" v-else src="@/assets/imgs/AutumnFestival/directPurchasing/3.png" alt="">
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="directPurchasingConfirmFun">确认</div>
            </div>

            <div class="CurrencySurplus">
                白金币剩余：{{ seeData.drawTokenBalance }}
            </div>
        </div>
        <el-dialog :visible.sync="prizePreviewVisible" :title="prizePreviewName || '奖品大图'"
            custom-class="autumn-prize-image-preview"
            append-to-body width="min(90vw, 680px)" :close-on-click-modal="true">
            <img v-if="prizePreviewVisible" :src="prizePreviewUrl" :alt="prizePreviewName"
                style="display:block;width:100%;height:60vh;object-fit:contain" />
        </el-dialog>
    </div>
</template>

<!-- 放大弹窗挂载在 body，使用专属类名避免影响其他活动。 -->
<style>
.el-dialog.autumn-prize-image-preview {
    background: transparent;
    box-shadow: none;
}
.autumn-prize-image-preview .el-dialog__header {
    padding: 0;
    height: 0;
}
.autumn-prize-image-preview .el-dialog__title {
    display: none;
}
.autumn-prize-image-preview .el-dialog__body {
    padding: 0;
    background: transparent;
}
.autumn-prize-image-preview .el-dialog__headerbtn {
    top: -32px;
    right: 0;
    z-index: 1;
    font-size: 28px;
}
.autumn-prize-image-preview .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
}
</style>

<script>
import axios from "axios";
import Cookies from "js-cookie";
export default {
    props: {
        seeType: String,
        seeData: { type: [Object, Array] },
    },
    data() {
        return {
            infoData: [],
            total: 0,
            selectedItem: null,
            prizePreviewVisible: false,
            prizePreviewUrl: '',
            prizePreviewName: '',
            attendanceClaiming: false,
            conversion_number: 1,
            loading: null,
            modeType: 'COUPLE',
            rankList: [],
            RecordList: [],
        }
    },
    mounted() {
        if (this.seeType == 'Record') {
            this.RecordFun(1)
        } else if (this.seeType == 'Ranking') {
            this.RankingFun()
        }

    },
    methods: {
        previewPrize(item) {
            const url = item.itemImg || item.imageUrl;
            if (!url) return;
            this.prizePreviewUrl = url;
            this.prizePreviewName = item.name || item.itemName || item.bundleName || '奖品大图';
            this.prizePreviewVisible = true;
        },

        // 切换产看记录
        pagination_change(e) {
            // this.RecordFun(e)
            this.RecordFun(e)

        },
        RecordFun(pageNum) {
            axios({
                method: "post",
                url: "/activityV2/getDrawRecords",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    pageNum,
                    pageSize: 10,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) { 
                        const list = res.data.data.list;

                        this.RecordList = list.flatMap(item => {
                            const currentLevel = item.level;

                            // 核心逻辑：优先取 rewards，如果没有或为空，则尝试取 voucher
                            // 注意：voucher 是对象，必须用 [] 包裹成数组才能使用 .map()
                            const sourceList = (item.rewards && item.rewards.length > 0)
                                ? item.rewards
                                : (item.voucher ? [item.voucher] : []);

                            return sourceList.map(reward => ({
                                ...reward,        // 保留原有的 itemImg, quantity, name 等数据
                                level: currentLevel // 注入层级信息
                            }));
                        });
                        this.total = res.data.data.total
                        // this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        RankingFun() {
            axios({
                method: "post",
                url: "/activityV2/getHeartRank",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.infoData = res.data.data
                        // this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        selectItem(item) {
            this.selectedItem = item;
        },
        ExchangeLotteryCurrencyConfirmFun() {
            if (this.conversion_number > this.seeData.drawTokenBalance) {
                this.$message.info('白金币不足！！！')
            } else {
                axios({
                    method: "post",
                    url: "/pieceLotteryV2/exchangeCoin",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        exchangeNum: this.conversion_number,
                        drawTokenCode: 'piece_draw_202608_1',
                        userId: Cookies.get("wx_userId"), // userId
                        platForm: "web",
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            this.$message.success(res.data.message)
                            this.$emit('seeConfirm', { type: 'Exchange' })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    });
            }
        },
        // 兑换奖励
        ExchangeRewardsFun(item) { 
            this.loading = this.$loading({
                // lock: true,
                text: '兑换中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: "/activityV2/exchangeVoucher",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    level: this.seeData.level,
                    activityCode: 'zhongqiu_2026',
                    rewardNo: item.rewardNo,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.$message.success(res.data.message)
                        this.$emit('seeConfirm', { type: 'Exchange' })
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading.close();
                });

        },
        //全勤奖励领取
        FullAttendanceFun() { 
            if (!this.seeData.canClaimAttendanceReward || this.attendanceClaiming) return;
            if (!this.selectedItem || !this.selectedItem.rewardNo) {
                this.$message.info('请先选择一项全勤奖');
                return;
            }
            this.attendanceClaiming = true;
            this.loading = this.$loading({
                // lock: true,
                text: '领取中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: "/activityV2/claimAttendanceReward",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    signMode: this.seeData.signMode,
                    rewardNo: this.selectedItem.rewardNo,
                    activityCode: "zhongqiu_2026",
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.$message.success(res.data.message)
                        this.$emit('seeConfirm', { type: 'Exchange' })
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.attendanceClaiming = false;
                    this.loading.close();
                });
        },

        // 心直购兑换
        directPurchasingConfirmFun() { 
            if (this.seeData.price > this.seeData.drawTokenBalance) {
                this.$message.info('白金币不足！！！')
            } else {
                this.loading = this.$loading({
                    // lock: true,
                    text: '领取中....',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                axios({
                    method: "post",
                    url: "/activityV2/buyHeartPackage",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        packageId: this.seeData.packageId,
                        signMode: this.seeData.signMode,
                        userId: Cookies.get("wx_userId"), // userId
                        platForm: "web",
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            this.$message.success(res.data.message)
                            this.$emit('seeConfirm', { type: 'Exchange' })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    }).finally(() => {
                        this.loading.close();
                    });
            }
        },

        // 补签确认
        buqianConfirmFun() {
            if (20 > this.seeData.drawTokenBalance) {
                this.$message.info('白金币不足！！！')
            } else {
                this.loading = this.$loading({
                    // lock: true,
                    text: '补签中....',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                axios({
                    method: "post",
                    url: "/activityV2/makeupSign",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        dayNo: this.seeData.dayNo,
                        activityCode: "zhongqiu_2026",
                        signMode: this.seeData.signMode,
                        userId: Cookies.get("wx_userId"), // userId
                        platForm: "web",
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            this.$message.success(res.data.message)
                            this.$emit('seeConfirm', { type: 'Exchange' })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    }).finally(() => {
                        this.loading.close();
                    });
            }
        },



        tishiConfirmFun() {
            if (this.seeData.type == 'one') {
                this.$emit('seeReward', 'one')
            } else {
                this.$emit('seeReward', 'ten')
            }
        },
        // confirmSelection() {
        //     if (this.selectedItem) {
        //         console.log('选中的信息:', this.selectedItem);
        //         this.$emit('selectReward', this.selectedItem);
        //     }
        // }
        // 跳转充值页面
        goRechargeConfirmFun() {
            this.$router.push({ path: '/Recharge' })
        },
        // 切换模式
        // 切换模式
        switchMode(mode) {
            if (mode == 'COUPLE') {
                this.rankList = this.infoData.coupleRank.rankList
            } else {
                this.rankList = this.infoData.sisterRank.rankList
            }
            this.modeType = mode
        }
    }
}

</script>

<style lang="less" scoped>
.zoomable-prize {
    cursor: zoom-in;
}
.RewardModal {
    // width: 40vw !important;
    height: 400px !important;
}

.borderModal {
    position: relative;
    text-align: center;
    width: 30vw;
    min-width: 600px;
    // height: 100%;
    height: 70vh;
    min-height: 450px;
    border-radius: 10px;
    padding: 5px;

    background-image: url('~@/assets/imgs/AutumnFestival/TC_Bg.png');

    /* 关键属性：确保图片铺满整个容器，不重复，且保持比例 */
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    ::-webkit-scrollbar-thumb {
        background-color: #F0922C;
        border-radius: 8px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background-color: #D97B1F;
    }

    ::-webkit-scrollbar-track {
        background-color: #FFF1DC;
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #D97B1F;
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #F0922C;
        color: #fff;
    }

    /deep/ .el-pagination button:not(:disabled):hover {
        color: #D97B1F;
    }


    &.rules-modal {
        height: auto;
        min-height: 0;
        max-height: 85vh;
        box-sizing: border-box;
        padding: 24px 16px 16px;

        .Rules.p {
            position: relative;
            top: auto;
            left: auto;
            transform: none;
            width: 100%;
            height: auto;
            max-height: calc(85vh - 40px);
            padding: 0 4px;
            overflow-y: auto;
            color: #70452b;
            text-shadow: none;

            .rule-section {
                background: #fff7eb;
                border: 1px solid #edc99d;
                backdrop-filter: none;
                margin-bottom: 14px;

                &:last-child { margin-bottom: 0; }

                .section-title {
                    color: #a6531c;
                    text-shadow: none;
                    &::before { background: #F0922C; }
                }
            }

            .rule-list li {
                color: #70452b;
                .num { background: #d97b1f; }
            }

            .probability-table {
                border-color: #edc99d;
                background: #fffdf8;
                .tr {
                    border-bottom-color: #f0dcc3;
                    span { color: #70452b; }
                    &:nth-child(odd):not(.th) { background: #fff0dc; }
                    &.th {
                        background: #b65d16;
                        span { color: #fff; }
                    }
                }
            }
        }
    }

    .closed {
        position: absolute;
        top: -30px;
        right: -25px;
        width: 80px;
        height: 80px;
        object-fit: contain;
        cursor: pointer;
        z-index: 10;
    }

    .bg {
        width: 100%;
        height: 110%;
        max-height: 800px;
    }

    .p {
        position: absolute;
        top: 35px;
        width: 92%;
        height: 88%;
        left: 50%;
        transform: translateX(-50%);
        overflow: auto;
    }

    .RankBody {
        top: 65px;
        overflow: visible !important;
        position: relative;

        .signIn_mode {
            position: absolute;
            left: -15px;
            top: -65px;
            display: flex;
            gap: 12px;

            z-index: 20;

            .mode_item {
                position: relative;

                height: 32px;
                padding: 0 14px;

                display: flex;
                align-items: center;
                gap: 6px;

                color: #8253f6;

                font-size: 13px;
                font-weight: bold;

                background: rgba(255, 255, 255, .9);

                border: 1px solid #bd25b8;
                border-radius: 18px;

                cursor: pointer;

                transition: .2s;

                &.active {
                    color: #fff;

                    background: #8253f6;

                    box-shadow: 0 2px 5px rgba(189, 37, 184, .25);
                }
            }
        }

        .tit {
            width: 100%;
            display: flex;
            margin-bottom: 20px;

            >div {
                flex: 1;
                font-size: 17px;
                font-weight: 800;
                color: #fff;
                user-select: none;
                text-shadow: -1px -1px 0 #8253f6, 1px -1px 0 #8253f6,
                    -1px 1px 0 #8253f6, 1px 1px 0 #8253f6;
            }
        }

        .items {
            width: 100%;
            height: 93%;
            overflow-y: auto;
            margin: auto;

            .itemList {
                width: 100%;
                height: 30px;
                line-height: 30px;
                display: flex;
                margin-bottom: 20px;

                >div {
                    height: 100%;
                    flex: 1;
                    font-size: 18px;
                    font-weight: 700;
                    color: #fff;
                    user-select: none;
                    text-wrap: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-shadow:
                        /* 左上角投影 */
                        -1px -1px 0 #8253f6,
                        /* 右上角投影 */
                        1px -1px 0 #8253f6,
                        /* 左下角投影 */
                        -1px 1px 0 #8253f6,
                        /* 右下角投影 */
                        1px 1px 0 #8253f6;
                }

            }
        }
    }

    // 记录
    .Record {
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .tit > div,
        .items .itemList > div {
            text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff,
                -1px 1px 0 #fff, 1px 1px 0 #fff;
        }

        .tit {
            width: 100%;
            display: flex;
            margin-bottom: 20px;

            >div {
                flex: 1;
                font-size: 17px;
                font-weight: 800;
                color: #F0922C;
                user-select: none;
            }
        }

        .items {
            width: 96%;
            height: 88%;
            overflow-y: auto;
            margin: auto;

            .itemList {
                width: 100%;
                height: 30px;
                line-height: 30px;
                display: flex;
                margin-bottom: 20px;

                >div {
                    height: 100%;
                    flex: 1;
                    font-size: 18px;
                    font-weight: 700;
                    color: #F0922C;
                    user-select: none;
                    text-wrap: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

            }
        }

        .Record_btn {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    //规则
    .Rules {
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        padding: 10px 5px;
        box-sizing: border-box;
        color: #ffffff;

        /* 1. 活动时间卡片（优化渐变与柔和度） */
        .time-card {
            background: linear-gradient(135deg, #e8ddff 0%, #fbe4ff 100%);
            /* 融入七夕粉紫浪漫渐变 */
            border-left: 4px solid #9b61ff;
            /* 换成配套的紫色边框 */
            border-radius: 8px;
            padding: 10px 16px;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: bold;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);

            .clock-icon {
                margin-right: 6px;
                font-size: 16px;
            }

            .time-title {
                color: #6b3ba7;
                /* 深紫灰色，提升浅色背景上的对比度和质感 */
                margin-right: 4px;
            }

            .time-text {
                color: #2c233d;
                /* 暗紫黑，确保文本清晰易读 */
                font-weight: bold;
            }
        }

        /* 2. 通用板块样式 */
        .rule-section {
            background: rgba(85, 78, 128, 0.65);
            /* 略微微调背景紫调，更显质感 */
            border: 1px solid rgba(255, 255, 255, 0.25);
            border-radius: 12px;
            padding: 16px 18px;
            margin-bottom: 16px;
            backdrop-filter: blur(8px);
            text-align: left;

            .section-title {
                font-size: 16px;
                font-weight: bold;
                color: #e5d8ff;
                margin-bottom: 14px;
                display: flex;
                align-items: center;
                letter-spacing: 0.5px;
                text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);

                &::before {
                    content: '';
                    display: inline-block;
                    width: 4px;
                    height: 16px;
                    background: #c19bfb;
                    margin-right: 8px;
                    border-radius: 2px;
                }
            }
        }

        /* 3. 核心规则列表 */
        .rule-list {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                font-size: 13px;
                line-height: 1.6;
                margin-bottom: 10px;
                display: flex;
                align-items: flex-start;
                color: #ffffff;

                &:last-child {
                    margin-bottom: 0;
                }

                b {
                    color: #ffe600;
                    /* 高亮关键字黄字 */
                    font-weight: bold;
                }

                .num {
                    background: #8751db;
                    /* 调整为紫色编号标，与全局主题统一 */
                    color: #ffffff;
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 11px;
                    font-weight: bold;
                    margin-right: 8px;
                    flex-shrink: 0;
                    margin-top: 2px;
                }

                .content {
                    flex: 1;
                    text-align: left;
                }
            }
        }

        /* 4. 概率表格（优化多列比例） */
        .probability-table {
            width: 100%;
            max-width: 100%;
            margin: 8px auto;
            border: 1px solid rgba(255, 255, 255, 0.25);
            border-radius: 8px;
            overflow: hidden;

            .tr {
                display: flex;
                border-bottom: 1px solid rgba(255, 255, 255, 0.15);
                font-size: 13px;

                &:last-child {
                    border-bottom: none;
                }

                /* 四列总宽度包含内边距，避免新增保底列后溢出。 */
                span {
                    box-sizing: border-box;
                    min-width: 0;
                    padding: 8px 10px;
                    text-align: center;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:nth-child(1) {
                        flex: 0 0 15%;
                    }

                    &:nth-child(2) {
                        flex: 0 0 49%;
                        // justify-content: flex-start;
                        /* 奖励名称左对齐，阅读更舒适 */
                        text-align: center;
                    }

                    &:nth-child(3) {
                        flex: 0 0 18%;
                    }

                    &:nth-child(4) {
                        flex: 0 0 18%;
                    }

                    &.highlight {
                        color: #ffe600;
                        font-weight: bold;
                    }
                }

                &.th {
                    background: #b65d16;
                    font-weight: bold;

                    span {
                        color: #ffffff;
                        justify-content: center;
                        /* 表头统一居中 */
                        text-align: center;
                    }
                }
            }
        }

        /* 5. 声明板块 */
        .statement-box {
            .warning-title {
                color: #ffd8d8;
                /* 声明标题微调为暖柔色，起到警示又不过于突兀的作用 */

                &::before {
                    background: #c19bfb;
                }
            }

            .statement-list {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    font-size: 13px;
                    line-height: 1.6;
                    color: #ffffff;
                    margin-bottom: 10px;
                    display: flex;
                    align-items: flex-start;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    b {
                        color: #ffe600;
                    }

                    .num {
                        background: #8751db;
                        color: #ffffff;
                        border: 1px solid rgba(255, 255, 255, 0.4);
                        width: 18px;
                        height: 18px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 11px;
                        font-weight: bold;
                        margin-right: 8px;
                        flex-shrink: 0;
                        margin-top: 2px;
                    }

                    .content {
                        flex: 1;
                        text-align: left;
                    }
                }
            }
        }
    }

    // 抽奖奖励
    .Reward {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;

        .item {
            width: 20%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 10px;

            .RewardImg {
                max-width: 70%;
            }
        }

        .btn {
            width: 100%;

            img {
                width: 30%;
                cursor: pointer;
            }
        }
    }

    // 商城兑换
    .Shop {
        .items {
            width: 100%;
            height: 70%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .tit {
                font-size: 2rem;

                span {
                    color: red;
                    font-size: 2.3rem;
                }
            }

            >img {
                max-width: 30%;
                max-height: 60%;
                margin: 20px 0px;

                .Shophit {
                    font-size: 1.5rem;
                }
            }
        }

        .ShopBtn {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            >div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
            }

            .ShopConfirm {

                background: #F0922C;
                color: #fff;
            }

            .ShopClosed {
                background-color: rgb(255, 255, 255);
                color: #F0922C;
            }
        }
    }

    // 追加奖励选择
    .RewardSelection {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px 10px;
        align-items: center;

        .items {
            width: 19%;
            max-height: 220px;
            padding: 10px;
            display: flex;
            background-color: #ffffff57;
            border-radius: 20px;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            cursor: pointer;
            border: 2px solid #ffffff57;
            gap: 20px;

            .sex {
                width: 100%;
                height: 10%;
                text-align: left;

                >img {
                    max-width: 28px;
                }
            }

            img {
                max-width: 60px;
            }
        }

        .items:hover {
            background-color: #f19ef2;
            color: #fff;
        }

        .items.selected {
            background-color: #f19ef2;
            color: #fff;
            border: 2px solid #ff69b4;
        }

        .RewardSelection {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;

            .btn {
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: repeating-linear-gradient(to left, rgb(252, 162, 242), rgb(235, 151, 249), rgb(255, 163, 240));
                color: rgb(255, 255, 255);
            }

            .btn.attendance-claim-btn {
                font-size: 20px;
            }

            .btn.disabled {
                background: #ccc;
                cursor: not-allowed;
                color: #999;
            }
        }
    }

    .attendance-hint {
        width: 100%;
        text-align: center;
        margin-bottom: 16px;
    }

    // 兑换
    .Exchange {
        height: 90%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 20px;

        .hint {
            font-size: 20px;
            color: #fff;
            font-weight: 700;
            text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;
        }

        .conversion_img {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 20px 0;

            >img {
                max-height: 80px;
            }

            >p {
                font-size: 50px;
                font-weight: 600;
                margin: 0 50px;
                color: #fff;
                font-family: Verdana, Geneva, Tahoma, sans-serif;
                text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;
            }
        }

        .conversion_input {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            left: -5%;

            span {
                font-size: 24px;
                margin-right: 30px;
                color: #fff;
                font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
                text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;

            }

            input {
                line-height: 40px;
                border-radius: 20px;
                text-align: center;
                font-size: 20px;
                background-color: #fff;
                border: 1px solid #ff1973ff;
                color: #ff1973ff;
            }

            input:focus {
                outline: 2px solid #fce18d;
                border: 1px solid #fce18d;

                /* 获得焦点时显示绿色轮廓 */
            }

        }

        .ConfirmExchange {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: repeating-linear-gradient(to left, rgb(252, 162, 242), rgb(235, 151, 249), rgb(255, 163, 240));
                color: rgb(255, 255, 255);
                box-shadow: 0 0 8px #ff1973ff;
            }

            .ShopConfirm:hover {
                background: #ff197382;
            }
        }

        .CurrencySurplus {
            padding: 20px;
            background-color: #ff197382;
            border-radius: 20px;
            font-size: 20px;
            color: #fff;
            font-weight: 700;
        }
    }

    // 跳转充值页面
    .goRecharge {
        height: 90%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 20px;

        .hint {
            font-size: 20px;
            color: #fff;
            font-weight: 700;
            text-shadow: -1px -1px 0 #8253f6, 1px -1px 0 #8253f6, -1px 1px 0 #8253f6, 1px 1px 0 #8253f6;
        }

        .ConfirmExchange {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: repeating-linear-gradient(to left, #8253f6, #8253f6, #8253f6);
                color: #fff;
                box-shadow: 0 0 8px #8253f6;
            }

            .ShopConfirm:hover {
                background: rgb(93, 162, 226);
            }
        }
    }


    // 抽奖提示
    .tishi {
        height: 90%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 20px;

        .hint {
            font-size: 20px;
            color: #fff;
            font-weight: 700;
            text-shadow: -1px -1px 0 #F0922C, 1px -1px 0 #F0922C, -1px 1px 0 #F0922C, 1px 1px 0 #F0922C;
        }

        .ConfirmExchange {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: linear-gradient(90deg, #F5AA4C 0%, #D97B1F 100%);
                color: #fff;
                box-shadow: 0 4px 15px rgba(181, 96, 15, 0.3);
            }

            .ShopConfirm:hover {
                background-position: right center;
                /* 触发背景移动 */
                transform: translateY(-2px) scale(1.05);
                /* 微微上浮并放大 */
                box-shadow: 0 6px 20px rgba(217, 123, 31, 0.45);
                /* 光晕变亮变大 */
            }
        }
    }

    // 奖池预览
    .PrizePool {
        padding: 10px;

        /* 标题提升：加金属光泽感与底纹 */
        .hint-title {
            text-align: center;
            margin-bottom: 15px;

            span {
                font-size: 20px;
                font-weight: 800;
                letter-spacing: 1px;
                background: linear-gradient(180deg, #FFFFFF 0%, #BFE3FF 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                /* 优雅的模糊阴影替代硬粗描边 */
                filter: drop-shadow(0 2px 4px rgba(0, 80, 180, 0.8));
            }
        }

        .items {
            display: flex;
            flex-wrap: wrap;
            gap: 12px 10px;
            justify-content: flex-start;
            padding: 5px;

            .item {
                position: relative;
                width: 31%; // 保持 3 列布局
                min-width: 95px;
                height: 170px;
                /* 固定高度确保对齐美观 */
                padding: 8px 6px;
                box-sizing: border-box;

                /* 玻璃拟态与渐变微光 */
                background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.08) 100%);
                backdrop-filter: blur(8px);
                border-radius: 14px;
                border: 1px solid rgba(255, 255, 255, 0.4);
                box-shadow: 0 4px 12px rgba(0, 30, 80, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.5);

                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                overflow: hidden;
                transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

                /* 悬浮动效：微抬 + 亮光 + 边框高亮 */
                &:hover {
                    transform: translateY(-4px) scale(1.02);
                    background: linear-gradient(135deg, rgba(255, 255, 255, 0.38) 0%, rgba(255, 255, 255, 0.15) 100%);
                    border-color: rgba(255, 255, 255, 0.8);
                    box-shadow: 0 8px 20px rgba(0, 100, 220, 0.3), inset 0 0 10px rgba(255, 255, 255, 0.6);

                    .prize_img {
                        transform: scale(1.1);
                    }
                }

                /* --- 稀有度颜色扩展 (可以在数据 item.quality 配置 'gold' | 'purple' | 'blue') --- */
                &.gold {
                    border-color: rgba(255, 215, 0, 0.6);
                    background: linear-gradient(135deg, rgba(255, 215, 0, 0.25) 0%, rgba(255, 255, 255, 0.08) 100%);
                }

                &.purple {
                    border-color: rgba(200, 120, 255, 0.6);
                    background: linear-gradient(135deg, rgba(180, 90, 255, 0.25) 0%, rgba(255, 255, 255, 0.08) 100%);
                }

                /* 性别角标优化 */
                .sex {
                    position: absolute;
                    top: 4px;
                    left: 6px;
                    z-index: 2;

                    img {
                        width: 35px;
                        height: 35px;
                        object-fit: contain;
                        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
                    }
                }

                /* 道具图片展示盒（加发光底座） */
                .img-wrapper {
                    position: relative;
                    width: 100%;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    /* 道具下方微弱圆形高光底座 */
                    &::after {
                        content: '';
                        position: absolute;
                        width: 40px;
                        height: 12px;
                        bottom: 2px;
                        background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 70%);
                        border-radius: 50%;
                        pointer-events: none;
                    }

                    .prize_img {
                        max-width: 100px;
                        max-height: 100px;
                        object-fit: contain;
                        filter: drop-shadow(0 4px 6px rgba(0, 20, 50, 0.3));
                        transition: transform 0.3s ease;
                    }
                }

                /* 道具名字与数量盒子 */
                .name-box {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    z-index: 2;

                    .name {
                        width: 100%;
                        font-size: 12px;
                        font-weight: 700;
                        text-align: center;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        /* 超出省略号，防止换行丑陋 */
                        line-height: 1.2;
                        margin: 0;
                        color: #fff;
                        text-shadow: -1px -1px 0 #F0922C, 1px -1px 0 #F0922C,
                            -1px 1px 0 #F0922C, 1px 1px 0 #F0922C;
                    }

                    /* 数量变成精致的小气泡 */
                    .num-tag {
                        font-size: 11px;
                        font-weight: 800;
                        color: #FFE600;
                        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
                        margin-top: 1px;
                    }
                }

                .Obtain {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    width: 40%;
                    z-index: 2;
                }
            }

            .obtained {
                filter: grayscale(100%);
            }

        }

    }

    // 心直购  提示
    .directPurchasing {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        padding: 20px;
        box-sizing: border-box;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;

        .hint {
            font-size: 20px;
            color: #fff;
            font-weight: 700;
            text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;
        }

        .Gift {
            width: 30%;
        }

        .ConfirmExchange {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: linear-gradient(90deg, #ff69b4 0%, #af25ad 100%);
                color: #fff;
                box-shadow: 0 4px 15px rgba(175, 37, 173, 0.4);
            }

            .ShopConfirm:hover {
                background-position: right center;
                /* 触发背景移动 */
                transform: translateY(-2px) scale(1.05);
                /* 微微上浮并放大 */
                box-shadow: 0 6px 20px rgba(255, 105, 180, 0.7);
                /* 光晕变亮变大 */
            }
        }

        .CurrencySurplus {
            padding: 20px;
            background-color: #ff197382;
            border-radius: 20px;
            font-size: 20px;
            color: #fff;
            font-weight: 700;
        }
    }


    .hit.exchange-hint {
        color: #75451f;
        text-shadow: none;
        font-size: 14px;
        line-height: 1.5;
        text-align: center;
        margin: 8px 0;

        .exchange-guide {
            font-size: 13px;
            margin-bottom: 5px;
        }

        .voucher-counts {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 6px 12px;

            span {
                padding: 2px 12px;
                border-radius: 12px;
                background: rgba(255, 248, 230, .65);
                white-space: nowrap;
            }

            b { margin-left: 4px; }
            .available-count { color: #a64712; background: #fff0ce; }
        }
    }

    .hit {
        position: absolute;
        bottom: 0;
        width: 92%;
        left: 50%;
        transform: translateX(-50%);
        float: left;
        margin: 10px 0;
        color: red;
        font-size: 17px;
        text-shadow:
            /* 左上角投影 */
            -1px -1px 0 #ffffff,
            /* 右上角投影 */
            1px -1px 0 #ffffff,
            /* 左下角投影 */
            -1px 1px 0 #ffffff,
            /* 右下角投影 */
            1px 1px 0 #ffffff;
    }
}
</style>
